<template>
    <div>
        <v-container style="direction: ltr">
            <div>جار تسجيل الخروج ...</div>
        </v-container>
    </div>
</template>

<script>
import store from "@/store";
import { __HTTP, FormHeader } from "@/utils/utils";

export default {
    name: "Logout",
    mounted() {
        __HTTP("?do=logout", {}, FormHeader, () => {
            store.dispatch("setLogout");
            localStorage.removeItem("user_info");
            localStorage.removeItem("token");
            this.$router.push({ name: "Login" });
        });
    },
};
</script>

<style scoped></style>
